import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { push } from 'connected-react-router';

import { notification } from '../../../actionTypes';
import { userTypes } from '../../../utils/constants';
import { formatPath } from '../../../utils/textFormaters';
import { downloadStoredPsmAuditPdf } from '../../../utils/psmAuditPdf';
import routes from '../../routes/path';

const AuditDocumentDownload = () => {
  const dispatch = useDispatch();
  const { companyId, auditId } = useParams();

  const userId = useSelector(state => state.auth.check.userId);
  const { companyType } = useSelector(state => state.entity.user[userId] || {});

  useEffect(() => {
    const downloadAndRedirect = async () => {
      try {
        await downloadStoredPsmAuditPdf({ id: auditId });
      } catch (e) {
        dispatch({ type: notification.add, payload: { error: e.message } });
      }

      const relocationPath =
        companyType === userTypes.Contractor
          ? routes.private.index
          : formatPath(routes.private.company.id, { id: companyId });

      dispatch(push(relocationPath));
    };

    downloadAndRedirect();
  }, [auditId, companyId, companyType, dispatch]);

  return '';
};

export default AuditDocumentDownload;
